var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "collapse",
    { attrs: { title: _vm.title } },
    [
      _vm.isAmendment
        ? _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function({ validated }) {
                    return [
                      _c("contracts", {
                        ref: "contractInfo",
                        attrs: {
                          contractors: _vm.contractors,
                          contracts: _vm.contracts,
                          "is-competition-process-from-mipe":
                            _vm.model.isCompetitionProcessFromMipe,
                          "is-read-only": _vm.isReadOnly
                        },
                        on: { "load-contracts": _vm.onLoadContracts },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "contract-error",
                              fn: function() {
                                return [
                                  validated &&
                                  !_vm.model.competitionProcessContracts?.length
                                    ? _c("error", {
                                        attrs: {
                                          message:
                                            "Debe haber al menos 1 contrato agregado.",
                                          variant: "no-border"
                                        }
                                      })
                                    : _vm._e()
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.model.competitionProcessContracts,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.model,
                              "competitionProcessContracts",
                              $$v
                            )
                          },
                          expression: "model.competitionProcessContracts"
                        }
                      })
                    ]
                  }
                }
              ],
              null,
              false,
              1200105199
            )
          })
        : _vm._e(),
      _vm.isAmendment
        ? _c("div", { staticClass: "bg-white m-2 p-3 rounded" }, [
            _c("strong", [_vm._v("Partida presupuestaria(s) actuales")]),
            _vm.model.isFromMipe
              ? _c(
                  "div",
                  [
                    _vm.pagination.data.length == 0
                      ? _c("custom-result-not-found", {
                          attrs: {
                            text: "No cuenta con información disponible."
                          }
                        })
                      : _vm._e(),
                    _vm._l(_vm.pagination.data, function(item, index) {
                      return _c("budget-sources", {
                        key: index,
                        attrs: { "is-read-only": true, item: item }
                      })
                    }),
                    _vm.showPagination
                      ? _c("pagination", {
                          attrs: { data: _vm.pagination, "show-text": "" },
                          on: { "pagination-go-page": _vm.goToPage }
                        })
                      : _vm._e()
                  ],
                  2
                )
              : _c(
                  "div",
                  { staticClass: "my-3" },
                  [
                    _c("budget-source-funds", {
                      attrs: {
                        "is-actual": "",
                        "is-read-only": _vm.isReadOnly,
                        model: _vm.model,
                        "program-types": _vm.programTypes
                      }
                    })
                  ],
                  1
                )
          ])
        : _vm._e(),
      _vm.isAmendment
        ? _c("div", { staticClass: "mb-3" }, [
            _c("label", [_vm._v(" Vigencia del contrato actual: ")]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-md" },
                [
                  !_vm.isReadOnly
                    ? _c("validation-provider", {
                        attrs: {
                          "custom-messages": {
                            required: "El campo es requerido."
                          },
                          rules: "required"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-date-picker", {
                                    staticClass: "w-100",
                                    attrs: {
                                      "custom-error-msg": errors[0],
                                      error: errors[0],
                                      label: "Fecha desde:",
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    model: {
                                      value:
                                        _vm.model
                                          .contractDetailOriginalValidityStartDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "contractDetailOriginalValidityStartDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "model.contractDetailOriginalValidityStartDate"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2884779320
                        )
                      })
                    : _vm.isReadOnly
                    ? _c("div", { staticClass: "my-2" }, [
                        _c("div", [_vm._v(" Fecha desde: ")]),
                        _c("label", { staticClass: "data-label" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("date")(
                                  _vm.model
                                    .contractDetailOriginalValidityStartDate
                                )
                              ) +
                              " "
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 col-md" },
                [
                  !_vm.isReadOnly
                    ? _c("validation-provider", {
                        attrs: {
                          "custom-messages": {
                            required: "El campo es requerido.",
                            afterStartDate:
                              "La fecha de finalización debe ser posterior a la fecha de inicio."
                          },
                          rules: {
                            required: true,
                            afterStartDate: {
                              start:
                                _vm.model
                                  .contractDetailOriginalValidityStartDate
                            }
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-date-picker", {
                                    staticClass: "w-100",
                                    attrs: {
                                      "custom-error-msg": errors[0],
                                      error: errors[0],
                                      label: "Fecha hasta:",
                                      "min-date": _vm.model
                                        .contractDetailOriginalValidityStartDate
                                        ? new Date(
                                            _vm.model.contractDetailOriginalValidityStartDate
                                          )
                                        : null,
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    model: {
                                      value:
                                        _vm.model
                                          .contractDetailOriginalValidityEndDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "contractDetailOriginalValidityEndDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "model.contractDetailOriginalValidityEndDate"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4207755097
                        )
                      })
                    : _vm.isReadOnly
                    ? _c("div", [
                        _c("div", [_vm._v(" Fecha hasta: ")]),
                        _c("label", { staticClass: "data-label" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("date")(
                                  _vm.model
                                    .contractDetailOriginalValidityEndDate
                                )
                              ) +
                              " "
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "mb-3" }, [
        _c("label", [_vm._v(" Contrato original se procuró vía: ")]),
        _c("div", { staticClass: "row mb-2" }, [
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("custom-radio", {
                staticClass: "custom-radio via",
                attrs: {
                  "custom-error-msg": "El campo es requerido.",
                  name: "contractDetailOriginalVia",
                  options: _vm.contractDetailOriginalViaOptions
                },
                model: {
                  value: _vm.contractDetailOriginalVia,
                  callback: function($$v) {
                    _vm.contractDetailOriginalVia = $$v
                  },
                  expression: "contractDetailOriginalVia"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "row d-flex align-items-center mb-2" }, [
              _c("div", { staticClass: "col-4 data-label text-right" }, [
                _vm._v(" Indicar cuantía de la cotización original ")
              ]),
              _c(
                "div",
                { staticClass: "col" },
                [
                  !_vm.isReadOnly && _vm.isViaQuotation
                    ? _c("validation-provider", {
                        attrs: {
                          "custom-messages": {
                            required: "El campo es requerido.",
                            min: "Favor de añadir un valor de cero o mayor."
                          },
                          rules: "required|min_value:0"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      calss: "w-100",
                                      "custom-error-msg": errors[0],
                                      error: errors[0],
                                      type: "number"
                                    },
                                    model: {
                                      value:
                                        _vm.contractDetailOriginalViaQuotation,
                                      callback: function($$v) {
                                        _vm.contractDetailOriginalViaQuotation = $$v
                                      },
                                      expression:
                                        "contractDetailOriginalViaQuotation"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3885578478
                        )
                      })
                    : _vm.isReadOnly && _vm.isViaQuotation
                    ? _c("label", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("empty")(
                                _vm.contractDetailOriginalViaQuotation
                              )
                            ) +
                            " "
                        )
                      ])
                    : _c("label", [_vm._v(" - ")])
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "row d-flex align-items-center mb-2" },
                  [
                    _c("div", { staticClass: "col-4 data-label text-right" }, [
                      _vm._v(
                        " Cantidad de años autorizados para la renovación "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        !_vm.isReadOnly && _vm.isViaRFP
                          ? _c("validation-provider", {
                              attrs: {
                                "custom-messages": {
                                  required: "El campo es requerido.",
                                  min:
                                    "Favor de añadir un valor de cero o mayor."
                                },
                                rules: "required|min_value:0"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          attrs: {
                                            calss: "w-100",
                                            "custom-error-msg": errors[0],
                                            disabled: !_vm.isViaRFP,
                                            error: errors[0],
                                            type: "number"
                                          },
                                          model: {
                                            value:
                                              _vm.contractDetailOriginalViaRenovationYearsQuantity,
                                            callback: function($$v) {
                                              _vm.contractDetailOriginalViaRenovationYearsQuantity = $$v
                                            },
                                            expression:
                                              "contractDetailOriginalViaRenovationYearsQuantity"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2355302769
                              )
                            })
                          : _vm.isReadOnly && _vm.isViaRFP
                          ? _c("label", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("empty")(
                                      _vm.contractDetailOriginalViaRenovationYearsQuantity
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          : _c("label", [_vm._v(" - ")])
                      ],
                      1
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "row d-flex align-items-center" }, [
                  _c("div", { staticClass: "col-4 data-label text-right" }, [
                    _vm._v(" Contratación original se firmó en el año ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      !_vm.isReadOnly && _vm.isViaRFP
                        ? _c("validation-provider", {
                            attrs: {
                              "custom-messages": {
                                required: "El campo es requerido.",
                                min: "Favor de añadir un valor de cero o mayor."
                              },
                              rules: "required|min_value:0"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-input", {
                                        attrs: {
                                          calss: "w-100",
                                          "custom-error-msg": errors[0],
                                          error: errors[0],
                                          type: "number"
                                        },
                                        model: {
                                          value:
                                            _vm.contractDetailOriginalViaSignatureYear,
                                          callback: function($$v) {
                                            _vm.contractDetailOriginalViaSignatureYear = $$v
                                          },
                                          expression:
                                            "contractDetailOriginalViaSignatureYear"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3157611047
                            )
                          })
                        : _vm.isReadOnly && _vm.isViaRFP
                        ? _c("label", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("empty")(
                                    _vm.contractDetailOriginalViaSignatureYear
                                  )
                                ) +
                                " "
                            )
                          ])
                        : _c("label", [_vm._v(" - ")])
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "mb-3" },
        [
          _c("label", [
            _vm._v(
              " Breve descripción del ámbito de los servicios incluyendo cualquier reporte a presentar: "
            )
          ]),
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required: "El campo es requerido."
                  },
                  rules: "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              maxlength: 10000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.contractDetailServiceDescription,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "contractDetailServiceDescription",
                                  $$v
                                )
                              },
                              expression:
                                "model.contractDetailServiceDescription"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2370771463
                )
              })
            : _vm.isReadOnly
            ? _c("div", { staticClass: "my-2 data-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("empty")(
                        _vm.model.contractDetailServiceDescription
                      )
                    ) +
                    " "
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mb-3" },
        [
          _c("label", [
            _vm._v(
              " Explicación y justificación de la " +
                _vm._s(_vm.contractLabel) +
                ". Explique por qué esta modificación al contrato es válida y como la misma es afín con la contratación original: "
            )
          ]),
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required: "El campo es requerido."
                  },
                  rules: "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              maxlength: 10000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.contractDetailJustification,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "contractDetailJustification",
                                  $$v
                                )
                              },
                              expression: "model.contractDetailJustification"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1826165020
                )
              })
            : _vm.isReadOnly
            ? _c("div", { staticClass: "my-2 data-label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("empty")(_vm.model.contractDetailJustification)
                    ) +
                    " "
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm.isAmendment
        ? _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("label", [
                _vm._v(" Cambio en la vigencia del contrato (si aplica): ")
              ]),
              _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required: "El campo es requerido."
                  },
                  rules: "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ validated }) {
                        return [
                          _c("custom-radio", {
                            staticClass: "custom-radio",
                            attrs: {
                              "custom-error-msg": "El campo es requerido.",
                              disabled: _vm.isReadOnly,
                              "is-inline": "",
                              name: "contractDetailValidityChanged",
                              options: _vm.yesNotOptions
                            },
                            model: {
                              value: _vm.contractDetailValidityChanged,
                              callback: function($$v) {
                                _vm.contractDetailValidityChanged = $$v
                              },
                              expression: "contractDetailValidityChanged"
                            }
                          }),
                          validated &&
                          ![true, false].includes(
                            _vm.contractDetailValidityChanged?.value
                          )
                            ? _c("error", {
                                attrs: {
                                  message: "El campo es requerido.",
                                  variant: "no-border"
                                }
                              })
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1295757415
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm.isRenewal ||
      (_vm.isAmendment && _vm.model.contractDetailValidityChanged)
        ? _c("div", [
            _c("label", [_vm._v(" Vigencia de contrato: ")]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-md" },
                [
                  !_vm.isReadOnly
                    ? _c("validation-provider", {
                        attrs: {
                          "custom-messages": {
                            required: "El campo es requerido."
                          },
                          rules: "required"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-date-picker", {
                                    staticClass: "w-100",
                                    attrs: {
                                      "custom-error-msg": errors[0],
                                      error: errors[0],
                                      label: "Fecha desde:",
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    model: {
                                      value:
                                        _vm.model
                                          .contractDetailValidityStartDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "contractDetailValidityStartDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "model.contractDetailValidityStartDate"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          340901121
                        )
                      })
                    : _vm.isReadOnly
                    ? _c("div", { staticClass: "my-2" }, [
                        _c("div", [_vm._v(" Fecha desde: ")]),
                        _c("label", { staticClass: "data-label" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("date")(
                                  _vm.model.contractDetailValidityStartDate
                                )
                              ) +
                              " "
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 col-md" },
                [
                  !_vm.isReadOnly
                    ? _c("validation-provider", {
                        attrs: {
                          "custom-messages": {
                            required: "El campo es requerido.",
                            afterStartDate:
                              "La fecha de finalización debe ser posterior a la fecha de inicio."
                          },
                          rules: {
                            required: true,
                            afterStartDate: {
                              start: _vm.model.contractDetailValidityStartDate
                            }
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-date-picker", {
                                    staticClass: "w-100",
                                    attrs: {
                                      "custom-error-msg": errors[0],
                                      error: errors[0],
                                      label: "Fecha hasta:",
                                      "min-date": _vm.model
                                        .contractDetailValidityStartDate
                                        ? new Date(
                                            _vm.model.contractDetailValidityStartDate
                                          )
                                        : null,
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    model: {
                                      value:
                                        _vm.model.contractDetailValidityEndDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "contractDetailValidityEndDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "model.contractDetailValidityEndDate"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2955805376
                        )
                      })
                    : _vm.isReadOnly
                    ? _c("div", [
                        _c("div", [_vm._v(" Fecha hasta: ")]),
                        _c("label", { staticClass: "data-label" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("date")(
                                  _vm.model.contractDetailValidityEndDate
                                )
                              ) +
                              " "
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm.isRenewal || _vm.isAmendment
        ? _c(
            "div",
            { staticClass: "my-3" },
            [
              _c("budget-source-funds", {
                attrs: {
                  "is-actual": false,
                  "is-read-only": _vm.isReadOnly,
                  model: _vm.model,
                  "program-types": _vm.programTypes
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c("strong", [
                            _vm._v(
                              " Partida presupuestaria y/o procedencia de los fondos "
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2248667064
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }